import {
  PermissionCategoryResponse,
  PermissionResponse,
} from '../../../../apollo/queries/v3/RolesNPermissions/permissionCategories.queries';
import { capitalizeString } from '../../../../utils/StringHelper';

interface Permission extends PermissionResponse {
  isChecked?: boolean;
}

export interface PermissionCategory
  extends Pick<PermissionCategoryResponse, 'id' | 'name'> {
  isChecked?: boolean;
  permissions: Permission[];
}

class PermissionCategoryViewModel {
  permissionCategories: PermissionCategory[] = [];
  totalPermissions: number = 0;

  constructor(permissionCategories: PermissionCategoryResponse[]) {
    this.generateData(permissionCategories);
  }

  generateData(pcResponse: PermissionCategoryResponse[]) {
    const reducer = (
      prev: { pc: PermissionCategory[]; totalPermissions: number },
      pc: PermissionCategoryResponse,
    ) => {
      let tp = 0;
      const newPc: PermissionCategory = {
        ...pc,
        isChecked: false,
        name: capitalizeString(pc.name),
        permissions: pc.permissions.map((p) => {
          tp += 1;
          return {
            ...p,
            isChecked: false,
          };
        }),
      };

      return {
        pc: [...prev.pc, newPc],
        totalPermissions: prev.totalPermissions + tp,
      };
    };

    const data = pcResponse.reduce(reducer, {
      pc: [],
      totalPermissions: 0,
    });

    this.permissionCategories = data.pc;
    this.totalPermissions = data.totalPermissions;
  }

  static areOnlySomeOfPermissionChecked = (permissions: Permission[]) => {
    const isPermissionChecked = (p: Permission) => p.isChecked;
    const areSomeSelected = permissions.some(isPermissionChecked);
    const areEverySelected = permissions.every(isPermissionChecked);

    return areSomeSelected && !areEverySelected;
  };
}

export default PermissionCategoryViewModel;
